import React,{ useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import {
  AppBar,
  Toolbar,
  Grid,
  Button,
  IconButton,
  styled,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import UserMenu from './UserMenu';
import NavigationDrawer from './Drawer/NavigationDrawer';
import MobileDrawer from './Drawer/MobileDrawer';
import logo from 'url:../../assets/images/logo.png';
import { NAVIGATION_DRAWER_WIDTH } from '../../utils/const';
import { useQuery } from 'react-query';
import { fetchDrawerInfo } from '../../api/drawer.api';
import { fetchEmployeeData } from '../../actions/employee.action';
import { navigationRoutes, createUserMenuRoutes } from '../../routes/routes';
import { logout } from '../../utils/auth';
import { resetState } from '../../actions/common.actions';
import AccountCircle from '@material-ui/icons/AccountCircle';

const Header = ({ history, drawerOpen, setDrawerOpen }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    dispatch(fetchEmployeeData());
  },[ dispatch ]);

  const drawerInfoQuery = useQuery(
    'drawerInfo',
    async () => {
      const { data } = await fetchDrawerInfo();
      return data;
    }
  );

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleLogOut = () => {
    logout();
    dispatch(resetState());
  };

  const StyledAppBar = styled(AppBar, {
    shouldForwardProp: prop => prop !== 'open'
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create([ 'width', 'margin' ], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
      marginLeft: NAVIGATION_DRAWER_WIDTH,
      width: `calc(100% - ${NAVIGATION_DRAWER_WIDTH}px)`,
      transition: theme.transitions.create([ 'width', 'margin' ], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    })
  }));

  const useStyles = makeStyles({
    logo: {
      height: 'auto',
      width: '100%',
      maxWidth: '140px'
    }
  });

  const classes = useStyles();

  return (
    <>
      <StyledAppBar
        position='relative'
        color={ 'primary' }
        open={ sm && drawerOpen }
      >
        <Toolbar>
          <Grid container direction={ 'row' } justifyContent="space-between">
            <Grid item container
              wrap="nowrap" direction={ 'row' } xs={ 8 } sm={ 5 } md={ 5 } alignItems="center"
            >
              { sm ?
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={ handleDrawerOpen }
                  color="inherit"
                  sx={ {
                    marginRight: '36px'
                  } }
                  style={ { display: drawerOpen && 'none' } }
                >
                  <MenuIcon />
                </IconButton> :
                <MobileDrawer
                  navigationRoutes={ navigationRoutes }
                  anchor={ 'left' }
                  icon={ < MenuIcon /> }
                  badgeInfo={ drawerInfoQuery.data }
                />
              }
              <Button component={ Link } to="/objectives">
                <img src={ logo } alt="logo"  className={ classes.logo }/>
              </Button>
            </Grid>
            { sm ?
              <UserMenu handleLogOut={ handleLogOut }/> :
              <MobileDrawer
                navigationRoutes={ createUserMenuRoutes(handleLogOut) }
                anchor={ 'right' }
                icon={ <AccountCircle /> }
              />
            }
          </Grid>
        </Toolbar>
      </StyledAppBar>
      { sm &&
        <NavigationDrawer
          drawerOpen={ drawerOpen }
          handleDrawerClose={ handleDrawerClose }
          handleDrawerOpen={ handleDrawerOpen }
          badgeInfo={ drawerInfoQuery.data }
        />
      }
    </>
  );
};

export default Header;
